import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b6b3c97a&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.9.8_0932247f44a9d1df17d411c64f0999d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports